import {formateNumber} from '../util';

/**
 * 深拷贝
 * @param {Object} 被复制的对象
 * @param {Object} 目标对象,默认为空对象
 * @return {Object}}
 */
function clone(obj, target) {
  target = target || {}
  for (var i in obj) {
    if (typeof obj[i] === 'object') {
      target[i] = (obj[i].constructor === Array) ? [] : {}
      clone(obj[i], target[i])
    } else {
      target[i] = obj[i]
    }
  }
  return target
}

/**
 * 从数组中移除一个对象
 * @param arr 数组对象
 * @param field 移除的字段匹配
 * @param text 匹配的值
 * @return {Boolean}
 */
function arrayRemoveOne(arr, field, text) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][field] === text) {
      arr.splice(i, 1)
      return true
    }
  }
  return false
}

/**
 * 判断对象是否为空对象
 * @param e 判断对象
 * @returns {boolean}
 */
function isEmptyObject(e) {
  if (!e) return true
  // vue 框架给数组添加了一个$remove的方法，所以对数组单独判断
  if (e instanceof Array) {
    return e.length === 0
  }
  return Object.keys(e).length === 0
}

/**
 * 压缩图片
 * @param file 图片文件
 * @param fileSize 图片文件的大小
 * @callBack 压缩完成后的回调函数，参数：(base64)
 */
function compress(file, callBack) {
  var img = new window.Image()
  // 最大宽度
  var maxW = 640
  // 压缩比
  var compressRate = 0.6

  img.onload = function () {
    var cvs = document.createElement('canvas')
    var ctx = cvs.getContext('2d')

    if (img.width > maxW) {
      img.height *= maxW / img.width
      img.width = maxW
    }
    cvs.width = img.width
    cvs.height = img.height
    ctx.clearRect(0, 0, cvs.width, cvs.height)
    ctx.drawImage(img, 0, 0, img.width, img.height)

    var dataUrl = cvs.toDataURL('image/jpeg', compressRate)
    if (typeof callBack === 'function') {
      callBack(dataUrl)
    }
  }

  img.src = file
}

/**
 * 冷却，防止快速重复点击
 * @param element 要冷却的节点
 * @param coolingTime 冷却时间（ms），默认为1000(ms)
 */
function coolingElement(element, coolingTime) {
  coolingTime = coolingTime || 1000
  if (typeof element === 'string') {
    element = document.getElementById(element)
  }
  element.disabled = true
  setTimeout(function () {
    element.disabled = false
  }, coolingTime)
}

/**
 * 字符串转bool
 * @param str
 * @returns {boolean}
 */
function strToBool(str) {
  if (typeof str === 'boolean') {
    return str
  } else if (typeof str === 'string') {
    return str === 'true'
  } else {
    return false
  }
}

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

/***
 * 节流函数 在wait间隔时间内不再进行任何调用时，触发一次最后的调用（如:wait设置为300ms，一直点击，该函数一直不执行，只有在间隔了300ms不做任何点击后，才执行刚才的最后一次点击）
 * @param func 执行函数
 * @param wait 等待时间
 * @param {Boolean} immediate 是否立即执行
 * @return {Function}
 */
function throttle(func, wait, immediate) {
  var timeout
  return function () {
    let context = this
    let args = arguments
    let later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    let callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

/***
 * 节流函数2 连续调用，每隔wait时间后触发一次（如:wait设置为300ms，一直点击，每隔300ms执行一次当前点击）
 * @param func 执行函数
 * @param wait 等待时间
 * @param {Boolean} immediate 是否立即执行
 * @return {Function}
 */
function throttle2(func, wait, immediate) {
  var timeout
  return function () {
    let context = this
    let args = arguments
    let later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    let callNow = immediate && !timeout
    if (!timeout) {
      timeout = setTimeout(later, wait)
    }
    if (callNow) func.apply(context, args)
  }
}

/**
 * base64数据转为Blob
 * @param {String} base64数据
 * @return {Object} Blob
 */
function dataURLtoBlob(base64Data) {
  let tmp = base64Data.split(',')
  if (tmp.length === 2) { // 如果base64包含头部的话，去掉base64的头
    tmp.shift()
  }
  var bytes = window.atob(tmp) // 转换为byte
  // 处理异常,将ascii码小于0的转换为大于0
  var ab = new ArrayBuffer(bytes.length)
  var ia = new Uint8Array(ab)
  for (var i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  return new window.Blob([ab], {type: 'application/octet-stream'})
}

/**
 * 比较两个对象是否相等
 * @param x
 * @param y
 * @returns {boolean}
 */
function cmp(x, y) {
  // If both x and y are null or undefined and exactly the same
  if (x === y) {
    return true
  }
  // If they are not strictly equal, they both need to be Objects
  if (!(x instanceof Object) || !(y instanceof Object)) {
    return false
  }
  // They must have the exact same prototype chain,the closest we can do is
  // test the constructor.
  if (x.constructor !== y.constructor) {
    return false
  }

  function innerCmp(a, b) {
    for (let p in a) {
      // Inherited properties were tested using x.constructor === y.constructor
      if (a.hasOwnProperty(p)) {  // eslint-disable-line
        // Allows comparing x[ p ] and y[ p ] when set to undefined
        if (!b.hasOwnProperty(p)) { // eslint-disable-line
          return false
        }
        // If they have the same strict value or identity then they are equal
        if (a[p] === b[p]) {
          continue
        }
        // Numbers, Strings, Functions, Booleans must be strictly equal
        if ((typeof (a[p]) !== 'object') || (a[p] === null && b[p]) || (a[p] && b[p] === null)) {
          return false
        }
        let tmptag = innerCmp(a[p], b[p])
        if (tmptag === false) return false
        continue
        // if (x[p] !== y[p]) return false
        // Objects and Arrays must be tested recursively
      }
    }
    for (let q in b) {
      // allows x[ p ] to be set to undefined
      if (b.hasOwnProperty(q) && !a.hasOwnProperty(q)) { // eslint-disable-line
        return false
      }
    }
  }

  let tmpTag = true
  tmpTag = innerCmp(x, y)
  if (tmpTag === false) return false
  return true
}

/**
 * @Description: 获取当前时间格式
 * @author zhangkang
 * @date 2020/6/5
 */
function getNowFormatDate() {
  let nowDate = {}
  let dateTime = new Date()
  let week
  // switch判断
  switch (dateTime.getDay()) {
    case 1:
      week = '星期一'
      break
    case 2:
      week = '星期二'
      break
    case 3:
      week = '星期三'
      break
    case 4:
      week = '星期四'
      break
    case 5:
      week = '星期五'
      break
    case 6:
      week = '星期六'
      break
    default:
      week = '星期天'
      break
  }
  // 年
  let year = dateFormat(dateTime.getFullYear())
  // 月
  let month = dateFormat(dateTime.getMonth() + 1)
  // 日
  let day = dateFormat(dateTime.getDate())
  // 时
  let hours = dateFormat(dateTime.getHours())
  // 分
  let minutes = dateFormat(dateTime.getMinutes())
  // 秒
  let seconds = dateFormat(dateTime.getSeconds())
  // 拼接年月日时分秒
  nowDate.currentdate = `${year}年${month}月${day}日 ${week} ${hours}：${minutes}：${seconds}`
  nowDate.date = year + '年' + month + '月' + day + '日 '
  nowDate.week = week
  nowDate.time = hours + '：' + minutes + '：' + seconds
  return nowDate
}

/**
 * @Description: 日期格式化
 * @author zhangkang
 * @date 2020/6/5
 */
function dateFormat(date) {
  return date < 10 ? `0${date}` : date
}
/**
    * @Description: 页面跳转方法
    * @author zhangkang
    * @date 2020/6/8
    */
function goToURL(name, url, params) {
  this.$router.push({
    name: name,
    path: url,
    params: params
  })
}
/**
 * @Description:校验特殊字符
 * @author wanghongling
 * @createDate 2020/8/6
 */
function checkSpecificKey(str) {
  var specialKey = "[`~!#@$^&*()=|{}':;',\\[\\]\".<>/?~！#￥……&*（）_——|{}【】‘；：”“'。，、？-]‘'"
  for (var i = 0; i < str.length; i++) {
    if (specialKey.indexOf(str.substr(i, 1)) !== -1) {
      return false
    }
  }
  return true
}



var formatTime = ({date}) => {
  var dateTime = {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear(),
    sec: date.getSeconds(),
    min: date.getMinutes(),
    hour: date.getHours()
  }
  var formatNumbers = ['month', 'day', 'sec', 'min', 'hour']
  formatNumbers.forEach(v => {
    dateTime[v] = formateNumber(dateTime[v])
  })
  return {
    date: `${dateTime.year}-${dateTime.month}-${dateTime.day}`,
    time: `${dateTime.hour}:${dateTime.min}:${dateTime.sec}`,
    dateTime: `${dateTime.year}-${dateTime.month}-${dateTime.day} ${dateTime.hour}:${dateTime.min}:${dateTime.sec}`
  }
}


export {
  clone,
  arrayRemoveOne,
  compress,
  coolingElement,
  isEmptyObject,
  strToBool,
  getQueryString,
  throttle,
  throttle2,
  dataURLtoBlob,
  cmp,
  getNowFormatDate,
  dateFormat,
  goToURL,
  checkSpecificKey,
  formatTime
}



// WEBPACK FOOTER //
// ./src/utils/index.js